import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';

const PrivacyPolicy = () => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language.startsWith('ar');

    return (
        <div className={`min-h-screen bg-page-gradient py-12 px-4 sm:px-6 lg:px-8 ${isArabic ? 'text-right' : 'text-left'}`}>
            <div className="max-w-4xl mx-auto bg-bg-card border border-black/5 rounded-xl shadow-2xl overflow-hidden p-8">
                <div className="mb-8 border-b border-gold/10 pb-6">
                    <div className="flex justify-between items-start mb-4">
                        <Link to="/" className="text-gold hover:text-white flex items-center gap-2 transition-colors">
                            {isArabic ? <>&rarr;</> : <>&larr;</>} {t('backToHome') || "Back to Home"}
                        </Link>
                        <LanguageSwitcher variant="dark" />
                    </div>
                    <h1 className="text-3xl font-bold text-text mb-2">{t('privacyPolicy') || "Privacy Policy"}</h1>
                    <p className="text-text-muted text-sm">{t('lastUpdated') || "Last Updated"}: {new Date().toLocaleDateString(isArabic ? 'ar' : 'es')}</p>
                </div>

                <div className="prose prose-gray max-w-none text-text-muted space-y-6">
                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('privacyIntroTitle')}</h2>
                        <p>{t('privacyIntroText')}</p>
                    </section>

                    {/* ... (rest of the content is standard text and lists, prose handles it) ... */}
                    {/* Re-including the sections to ensure structure is kept */}
                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('privacyDataCollectTitle')}</h2>
                        <p>{t('privacyDataCollectText')}</p>
                        <ul className="list-disc pl-5 space-y-1 mt-2 text-textMuted">
                            <li><strong>{t('privacyDataCollectList1Label')}:</strong> {t('privacyDataCollectList1Text')}</li>
                            <li><strong>{t('privacyDataCollectList2Label')}:</strong> {t('privacyDataCollectList2Text')}</li>
                            <li><strong>{t('privacyDataCollectList3Label')}:</strong> {t('privacyDataCollectList3Text')}</li>
                            <li><strong>{t('privacyDataCollectList4Label')}:</strong> {t('privacyDataCollectList4Text')}</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('privacyUsageTitle')}</h2>
                        <p>{t('privacyUsageText')}</p>
                        <ul className="list-disc pl-5 space-y-1 mt-2 text-textMuted">
                            <li>{t('privacyUsageList1')}</li>
                            <li>{t('privacyUsageList2')}</li>
                            <li>{t('privacyUsageList3')}</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('privacyRetentionTitle')}</h2>
                        <p>{t('privacyRetentionText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('privacyRightsTitle')}</h2>
                        <p>{t('privacyRightsText')}</p>
                        <ul className="list-disc pl-5 space-y-1 mt-2 text-textMuted">
                            <li>{t('privacyRightsList1')}</li>
                            <li>{t('privacyRightsList2')}</li>
                            <li>{t('privacyRightsList3')}</li>
                            <li>{t('privacyRightsList4')}</li>
                            <li>{t('privacyRightsList5')}</li>
                            <li>{t('privacyRightsList6')}</li>
                            <li>{t('privacyRightsList7')}</li>
                        </ul>
                        <p className="mt-2 text-textMuted">{t('privacyContactText')}</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
